import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { LatestFortnoxImportRuns } from '../../models/FortnoxImportRun';

/** The latest import run for base and for salary, or null where there has been none. */
export const useGetLatestFortnoxImports = () => {
  const { callAPI } = useAPI<LatestFortnoxImportRuns>({ method: 'GET' });

  const action = async (): Promise<LatestFortnoxImportRuns> =>
    (await callAPI(buildApiUrl('fortnoxImport/latest'))) as LatestFortnoxImportRuns;

  return { action };
};
